export default __webpack_public_path__ + "static/media/Bjorn_Axe.69988274.png";